import React from 'react';

import videoSrc from "assets/img/landing_placeholder.mp4";

const BackgroundVideo = () => {
  return (
    <div className="background-video-container">
      <video autoPlay muted loop className="background-video">
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="content">
        <h1>Welcome to My Website</h1>
        <p>This is some content on the page.</p>
      </div>
    </div>
  );
};

export { videoSrc, BackgroundVideo };
